import RSVPConfig from "RSVPConfig"
import altaConfig from "RSVPConfig/alta"
import portalOverrides from "portal.json"

let config
let locale = null
const ns = "portal"
const hasPortalOverrides = Object.keys(portalOverrides).length > 0

if (hasPortalOverrides) {
  // V2: portal.json provides all config and locale
  // Spread defaults first so archived portals (which omit config entirely) don't
  // leave consumers crashing on undefined when they access config.features at
  // module scope.
  config = { features: {}, ...(portalOverrides.config || {}) }
  locale = portalOverrides.locale || null
} else if (RSVPConfig) {
  // V1: WHITELABEL brand provides all config and locale
  config = RSVPConfig
  locale = { en: require(`locales/en/${config.name}.json`) }
} else {
  // No REACT_APP_WHITELABEL set (local dev without dynamic files) — mirror
  // the craco.config.js behaviour which also defaults ThemeDefaults to alta.
  config = altaConfig
  locale = { en: require("locales/en/alta.json") }
}

const archived = portalOverrides.archived === true

export default { config, locale, ns, archived }
